import StaffService from "@/service/StaffService";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { StaffEmgCont } from "@/model/StaffEmgCont";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import emergencyContactValidationObj from "./S070200-EmergencyContactValidation.js";
var employeeEmergencyValidationObj = new emergencyContactValidationObj();
export default {
  name: "emergencyContact",
  props: [
    "staffModel", "isEmergencyEditMode", "isEmergencyViewMode"
  ],
  data: () => ({
    contactLocalization: t,
    contactDictEnum: dictEnum,
    staffEmgCont: new StaffEmgCont(),
    relationshipList: [],
    listKey: 1,
    IsLoaded: true,
    emergencyContactObj: {
      selectAll: false
    },
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  mounted() {
    employeeEmergencyValidationObj.emergencyContactValidation();
    this.getAllRelationship();
  },
  methods: {
    async getAllRelationship() {
      const obj = {};
      const response = await StaffService.getAllRelationship(obj);
      if (response.data.IsSuccess) {
        this.relationshipList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnAddEmergencyContactButtonClick: function () {
      this.emergencyContactObj.selectAll = false;
      this.$validator.validateAll().then(result => {
        if (result) {
          var self = this;
          var tempCode = 1;
          var seq = 1;
          self.staffModel.StaffEmgConts.forEach(element => {
            element.IsEditMode = false;
            element.Seq = seq;
            element.tempCode = tempCode;
            tempCode++;
            seq++;
          });
          var staffEmgCont = new StaffEmgCont();
          staffEmgCont.StaffID = self.staffModel.StaffID;
          staffEmgCont.Seq = seq;
          staffEmgCont.tempCode = tempCode;
          staffEmgCont.IsEditMode = true;
          self.staffModel.StaffEmgConts.push(staffEmgCont);
        }
      });
    },
    OnEmergencyContactDeleteClick: function (data) {
      var self = this;
      self.staffModel.StaffEmgConts.forEach((element, index) => {
        if (element.tempCode == data.tempCode) {
          self.staffModel.StaffEmgConts.splice(index, 1);
          return;
        }
      });
    },
    OnEmergencyContactSelection: function (item) {
      var self = this;
      if (self.isEmergencyViewMode) {
        return;
      }
      if (item.IsEditMode) {
        return;
      }
      self.IsLoaded = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.staffModel.StaffEmgConts.forEach(element => {
            if (element.tempCode == item.tempCode) {
              self.IsLoaded = true;
              element.IsEditMode = true;
            } else {
              self.IsLoaded = true;
              element.IsEditMode = false;
            }
          });
          self.listKey += 1;
        }
        self.IsLoaded = true;
      });
    },
    changeRelationtype: function (item) {
      var self = this;
      var relationshipDetail = self.relationshipList.find(
        obj => obj.RelateType == item.RelateType
      );
      item.RelateTypeDes = self.user.Lang == 'EN' ? relationshipDetail.EDesc : relationshipDetail.CDesc;
    },
    selectAllContactRecord: function () {
      var self = this;
      var IsSelected = self.emergencyContactObj.selectAll;
      self.staffModel.StaffEmgConts.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    closeContactPopup: function () {
      $('#deleteContactModel').modal('hide');
    },
    deleteMultipleContactPopup: function () {
      var arrayList = [];
      var self = this;
      self.staffModel.StaffEmgConts.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteContactModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.contactLocalization.t(self.contactDictEnum.MSG_SelectDeleteRecord));
      }
    },
    deleteMultipleContact: function () {
      var self = this;
      var staffEmgConts = self.staffModel.StaffEmgConts.filter(
        obj => obj.isSelected !== true
      );
      self.staffModel.StaffEmgConts = staffEmgConts;
      self.emergencyContactObj.selectAll = false;
      $('#deleteContactModel').modal('hide');
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmergencyContact.js